import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableCellSizingDirective } from '@selfai-platform/shared';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { ConditionEditComponentModule } from '../../../../condition-edit/condition-edit.module';
import { EditSelectionFieldComponentModule } from '../../../../edit-selection-field/edit-selection-field.module';
import { LoggingComponentModule } from '../../logging/logging.module';
import { CreateTriggerComponent } from './create-trigger.component';

@NgModule({
  imports: [
    CommonModule,
    TableModule,
    InputTextModule,
    CheckboxModule,
    TooltipModule,
    ReactiveFormsModule,
    ButtonModule,
    EditSelectionFieldComponentModule,
    ConditionEditComponentModule,
    FormsModule,
    MessagesModule,
    TabViewModule,
    LoggingComponentModule,
    TableCellSizingDirective,
  ],
  declarations: [CreateTriggerComponent],
  exports: [CreateTriggerComponent],
})
export class CreateTriggerComponentModule {}
